import { render, staticRenderFns } from "./kbd.vue?vue&type=template&id=6c6c949e&scoped=true"
import script from "./kbd.vue?vue&type=script&lang=js"
export * from "./kbd.vue?vue&type=script&lang=js"
import style0 from "./kbd.vue?vue&type=style&index=0&id=6c6c949e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c949e",
  null
  
)

export default component.exports